<div class="row p-2" *ngIf="previsional; else loading" >
  <div class="col d-flex">
    <div class="card3 col-5">
      <div class="col">
        <h4 class="m-3"><strong>Indicadores</strong></h4>

        <div class="indicator-section">
          <div class="d-flex align-items-center">
            <img src="/assets/img/rentaMinima.png" width="90" height="70" alt="">
            <h3 class="ml-3">Renta Mínima imponible</h3>
          </div>
          <h4 class="value">{{previsional.RMITrabDepeInd | currency: 'CLP'}}</h4>
        </div>

        <p-divider></p-divider>

        <!-- Sección especial para Valor UF -->
        <div class="indicator-section">
          <div class="d-flex align-items-center">
            <img src="/assets/img/uf.png" width="90" height="70" alt="">
            <div class="d-blick">
              <h3 class="ml-3">Valor UF</h3>
              <h4 class="uf-title ml-3">{{previsional.UFDescPeridoAnt}}</h4>
              <h4 class="uf-title ml-3">{{previsional.UFDescPeriodo}}</h4>
          </div>
          </div>
          <div class="uf-details">
            <div class="uf-item d-flex justify-content-between">

              <h4 class="value">{{previsional.UFValPeriodoAnt | number}}</h4>
            </div>
            <div class="uf-item d-flex justify-content-between">

              <h4 class="value">{{previsional.UFValPeriodo | number}}</h4>
            </div>
          </div>
        </div>

        <p-divider></p-divider>

        <div class="indicator-section">
          <div class="d-flex align-items-center">
            <img src="/assets/img/utm.png" width="90" height="70" alt="">
            <h3 class="ml-3">UTM {{previsional.UTMDesc}}</h3>
          </div>
          <h4 class="value">{{previsional.UTMVal | currency: 'CLP'}}</h4>
        </div>

        <p-divider></p-divider>

        <div class="indicator-section">
          <div class="d-flex align-items-center">
            <img src="/assets/img/uta.png" width="90" height="70" alt="">
            <h3 class="ml-3">UTA</h3>
          </div>
          <h4 class="value">{{previsional.UTAVal | currency: 'CLP'}}</h4>
        </div>
        <p-divider></p-divider>

      </div>

      <div class="col col-12 text-center mb-0 mt-4">
        <!-- <a mat-flat-button style="color: white; text-decoration: none; background: #6366f1; padding: 8px 15px 8px 15px;" href="https://www.previred.com/indicadores-previsionales/" target="_blank">
              Ir a Indicadores de Previred
        </a> -->
        <p-button
        label="Ir a Indicadores Previred"
        icon="pi pi-angle-right"
        iconPos="right"
        styleClass="p-button-outlined p-button-help"
        (onClick)="goToPrevired()">
      </p-button>

      </div>
    </div>

    <div class="col-7 w-100">
    <div class="text-center">

  <div class="col col-12 text-center card3 p-5">
    <h2 class="text-center mb-2">Tasas AFP´s</h2>
    <canvas #barCanvas width="400" height="150"></canvas>
  </div>


  <!--aquii oponeeer enl otroooo adlasjldjadjslajdlkasjlaksjsjaalsj-->

  <div class="col col-12 card3 mt-2">
    <!-- ASIGNACION FAMILIAR -->
    <h2 class="text-center mb-3">Asignación Familiar (Tramos)</h2>
    <div id="carouselAsigFam" class="carousel slide mb-3" data-ride="carousel">
        <div class="carousel-inner">
            <!-- TRAMO A -->
            <div class="carousel-item active" data-interval="20000">
                <div class="d-block w-100">
                    <mat-card class="pb-1">
                        <mat-card-header class="d-flex justify-content-center">
                            <mat-card-title>A: {{previsional.AFamTramoAMonto | currency:'CLP'}} | Requisitos: entre $0 y {{previsional.AFamTramoAHasta | currency: 'CLP'}}</mat-card-title>
                        </mat-card-header>
                    </mat-card>
                </div>
            </div>
            <!-- TRAMO B -->
            <div class="carousel-item" data-interval="20000">
                <div class="d-block w-100">
                    <mat-card class="pb-1">
                        <mat-card-header class="d-flex justify-content-center">
                            <mat-card-title>B: {{previsional.AFamTramoBMonto | currency:'CLP'}} | Requisitos: entre {{previsional.AFamTramoBDesde | currency: 'CLP'}} y {{previsional.AFamTramoBHasta | currency: 'CLP'}}</mat-card-title>
                        </mat-card-header>
                    </mat-card>
                </div>
            </div>
            <!-- TRAMO C -->
            <div class="carousel-item" data-interval="20000">
                <div class="d-block w-100">
                    <mat-card class="pb-1">
                        <mat-card-header class="d-flex justify-content-center">
                            <mat-card-title>C: {{previsional.AFamTramoCMonto | currency:'CLP'}} | Requisitos: entre {{previsional.AFamTramoCDesde | currency: 'CLP'}} y {{previsional.AFamTramoCHasta | currency: 'CLP'}}</mat-card-title>
                        </mat-card-header>
                    </mat-card>
                </div>
            </div>
            <!-- TRAMO D -->
            <div class="carousel-item" data-interval="20000">
                <div class="d-block w-100">
                    <mat-card class="pb-1">
                        <mat-card-header class="d-flex justify-content-center">
                            <mat-card-title>D: {{previsional.AFamTramoDMonto | currency:'CLP'}} | Requisitos: mayor o igual {{previsional.AFamTramoDDesde | currency: 'CLP'}}</mat-card-title>
                        </mat-card-header>
                    </mat-card>
                </div>
            </div>
        </div>
        <a class="carousel-control-prev bg-secondary rounded-left" href="#carouselAsigFam" role="button"
            data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next bg-secondary rounded-right" href="#carouselAsigFam"
            role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
</div>
    </div>



<!--AQUI LAS TARKETAS DE PRUEBA-->
<!-- <div class="col col-12 text-center mb-0 mt-4">
<div class="card-afps">
  <h4>Tasas AFP's</h4>
</div>
</div> -->

</div>


      <!-- <div class="row">
          <div class="col col-3">
              <h2 class="text-center mb-0">Renta Minima Imponible</h2>
              &nbsp;
              <mat-card-title class="text-center border border-secondary rounded p-3">{{previsional.RMITrabDepeInd | currency: 'CLP'}}</mat-card-title>
          </div>
          <div class="col col-9">
              <h2 class="text-center mb-2">Valor UF</h2>
              <div class="row pr-2 pl-2">
                  <div class="col col-6">
                      <mat-card-title class="text-right border border-secondary rounded p-3">{{previsional.UFDescPeridoAnt}}: {{previsional.UFValPeriodoAnt | number}}</mat-card-title>
                  </div>
                  <div class="col col-6">
                      <mat-card-title class="text-right border border-secondary rounded p-3">{{previsional.UFDescPeriodo}} {{previsional.UFValPeriodo | number}}</mat-card-title>
                  </div>
              </div>
          </div>
      </div> -->
      <div class="row">

      </div>
      <div class="row">


      </div>
  </div>
</div>

<ng-template #loading >
  <div class="row">
      <div class="col-12">
          <div class="surface-section px-4 py-8 md:px-6 lg:px-8">
              <div class="text-700 text-center">
                  <div style="font-family: 'Plus Jakarta Sans', sans-serif!important;" class="text-900 font-bold text-5xl mb-3">Cargando datos previsionales...</div>
                  <i class="pi pi-spin pi-spinner mt-2" style="font-size: 3rem"></i>
              </div>
          </div>
      </div>
  </div>
</ng-template>
